<ion-modal #modalSpeechToText
    class="marv_modal_speech_to_text"  
    [backdropDismiss]="false"
    [canDismiss]="this.canDismissModal.bind(this)"
    (didDismiss)="this.onDidDismissModal($event)" 
    >   
    <ng-template>
                     
        <div class="marv_speech_to_text">

            @if(this.errorMessage !== ''){
                <marv-message type="error">{{this.errorMessage | translate}}</marv-message>
            }

            <div class="audio_status"
                [class.start_record]="this.marvSpeechToText?.startRecord"
                [class.audio_start_record]="this.marvSpeechToText?.audioStartRecord">
                @if(this.marvSpeechToText?.startRecord){
                    <ion-icon name="mic-outline"></ion-icon>
                }
                @else{                    
                    <ion-icon name="mic-off-outline" (click)="this.startSpeechRecognition()"></ion-icon>
                }
            </div>

            <marv-button icon="close-outline" [rounded]="true" color="secondary" size="medium" (click)="this.cancel()" /> 
        </div>            
        
    </ng-template>
</ion-modal>
